import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateSubCategoryRequest, UpdateSubCategoryRequest } from "./subCategorySlice";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { DeleteCategory } from "../category/categorySlice";
import { SubCategory } from "../../../types";

// Async Thunks
export const fetchSubCategories = createAsyncThunk<SubCategory[], void, { rejectValue: string }>(
    'subCategories/fetchSubCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<ApiResponse<SubCategory[]>>(apiEndpoints.subcategory.getAll);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch subcategories');
        }
    }
);

export const createSubCategory = createAsyncThunk<SubCategory[], CreateSubCategoryRequest, { rejectValue: string }>(
    'subCategories/createSubCategory',
    async (requestBody, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<SubCategory[]>>(apiEndpoints.subcategory.create, { data: requestBody });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to create subcategory');
        }
    }
);

export const updateSubCategory = createAsyncThunk<SubCategory, { id: string; data: UpdateSubCategoryRequest }, { rejectValue: string }>(
    'subCategories/updateSubCategory',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await api.put<ApiResponse<SubCategory>>(`${apiEndpoints.subcategory.update}/${id}`, { data });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update subcategory');
        }
    }
);

export const deleteSubCategory = createAsyncThunk<DeleteCategory, { id: string }, { rejectValue: string }>(
    'subCategories/deleteSubCategory',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApiResponse<DeleteCategory>>(`${apiEndpoints.subcategory.delete}/${id}`,);
            return { ...response.data, id };
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to delete subcategory');
        }
    }
);
